import { useState } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { Column } from "@components/EditableDataTable/types/column";
import { useV2ListGovernancesForAccountQuery } from "@generated";
import BlueprintItemsTab, { TabRow } from "./BlueprintItemsTab";
import type { BlueprintDetail } from "../../common/api";

const tabColumns: Column[] = [
  { header: () => "Name", cell: (row) => row.name },
  { header: () => "Calculation", cell: (row) => row.calculationType },
  { header: () => "Rate", cell: (row) => row.rate },
];

const catalogColumns: ColumnDef<TabRow>[] = [
  { header: "Name", cell: (props) => props.row.original.name },
  { header: "Calculation", accessorKey: "calculationType" },
  { header: "Rate", accessorKey: "rate" },
];

const toTabRow = (item: any, idx: number): TabRow => ({
  id: String(item.id ?? item.lid ?? `g_${idx}`),
  name: item.attributes?.description || "",
  calculationType: item.attributes?.["calculation-type"] || "",
  rate: item.attributes?.rate ?? "",
});

const toPayloadItem = (row: TabRow) => ({
  lid: crypto.randomUUID(),
  type: "project-governances",
  attributes: {
    description: row.name,
    "calculation-type": row.calculationType,
    rate: row.rate,
  },
  relationships: {
    governance: { data: { id: Number(row.id), type: "governances" } },
  },
});

const GovernanceTab = ({
  blueprint,
  refetch,
  readOnly,
}: {
  blueprint: BlueprintDetail;
  refetch: () => void;
  readOnly?: boolean;
}) => {
  const [search, setSearch] = useState("");

  const { data, isLoading } = useV2ListGovernancesForAccountQuery({
    filter: { active: true } as any,
    page: { number: 1, size: 500 },
  });

  const allItems: TabRow[] = (data?.data ?? []).map((g) => ({
    id: String(g.id),
    name: g.attributes?.name || "",
    calculationType: g.attributes?.["calculation-type"] || "",
    rate: g.attributes?.rate ?? "",
  }));

  const catalogItems = search
    ? allItems.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    : allItems;

  return (
    <BlueprintItemsTab
      blueprint={blueprint}
      refetch={refetch}
      payloadType="project-governances"
      toTabRow={toTabRow}
      toPayloadItem={toPayloadItem}
      tabColumns={tabColumns}
      catalogColumns={catalogColumns}
      catalogItems={catalogItems}
      catalogLoading={isLoading}
      onCatalogSearch={(q) => setSearch(q)}
      itemLabel="Governance"
      readOnly={readOnly}
    />
  );
};

export default GovernanceTab;
